<template>
  <el-select
    :value="value"
    @input="updateValue"
    :placeholder="placeholder"
    :clearable="!unclearable"
    style="width:100%;"
  >
    <el-option
      v-for="(item, key) in list"
      :key="key"
      :label="item.name"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
import myAxios from "@/utils/request";
export default {
  name: "enumerate", //数据枚举的公共组件
  props: ["url", "value", "placeholder", "unclearable", "defaultValue"],
  created() {
    this.load();
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    load() {
      myAxios.get(this.url).then(res => {
        //设定默认值
        if (this.$props.defaultValue) {
          res.enumList.some(item => {
            if (item.name === this.$props.defaultValue) {
              this.$emit("input", item.value);
              return true;
            }
          });
        }
        return (this.list = res.enumList);
      });
    },
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="less"></style>
